angular.module("Main").controller("PaymentKursCancelFailErrorController", ["$rootScope", "$scope", "$state", "$stateParams", "$location", "$translate", "PaymentService", "BookingService", "SessionService",
    function ($rootScope, $scope, $state, $stateParams, $location, $translate, PaymentService, BookingService, SessionService) {
        var vm = this;

        var logoutHandler = $rootScope.$on("logout", function () {
            SessionService.clear('globals', 'meetingData', 'meetingDate', 'kursData');
            //unregisterEventHandler();
            $state.go('kursplan', {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()});
        });
        BookingService.getCurrency().then(function (data) {
            vm.currency = data;
            if (vm.currency.Waehrung === "EUR")
                vm.currency.Waehrung = "€";
        });

        $scope.$on("destroy", function () {
            logoutHandler();
        });
        vm.clubId = SessionService.getAuthData();

        if ($stateParams.message)
            vm.message = $stateParams.message;

        vm.isKurs = true;
        vm.isTermin = false;

        getKursbuchungLayouKonfiguration();


        function getKursbuchungLayouKonfiguration() {
            BookingService.getKursbuchungLayouKonfiguration().then(function (data) {
                vm.kursbuchungConfig = data;
            });
        }

        if (!SessionService.getSessionId()) {
            $state.go("kursplan", {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()});
        } else
            init();

        function init() {
            vm.hasError = false;
            BookingService.deleteMemberFromAppointment($stateParams.oid).then(function () {
                PaymentService.cancelPayment($stateParams.rid);
            }).catch(function () {
                vm.hasError = true;
            });
        }

    }]);
